"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.coreInitiativesStatusesGetAsyncSlice = void 0;
const _api_1 = require("../../../api/index.js");
const xuder_1 = require("@sonar-software/xuder");
exports.coreInitiativesStatusesGetAsyncSlice = (0, xuder_1.createGetAsyncSlice)({
    name: 'CoreInitiativesStatuses',
    receive: true,
    request: false,
    requestHandler: () => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        const result = yield (0, _api_1.getInitiativeStatuses)();
        return Object.assign(Object.assign({}, result), { data: (_a = result.data) === null || _a === void 0 ? void 0 : _a.initiativeStatuses });
    }),
    yieldType: xuder_1.SagaYieldType.Latest
});
//# sourceMappingURL=get.js.map